if (typeof LevoTestimonial !== "function") {
  class LevoTestimonial extends HTMLElement {
    constructor() {
      super();

      this.testimonialsTexts = this.querySelectorAll("[data-label-by]");
      this.textsHolder = this.querySelector("[data-texts-holder]");
      this.testimonialsHandlers = this.querySelectorAll("[data-label]");
      this.currentIndex = 0;

      if (this.testimonialsTexts) {
        let highest = 0;
        this.testimonialsTexts.forEach((elem, index) => {
          if (index === 0) {
            elem.classList.add("active");
            highest = elem.offsetHeight;
          }
        });
        this.textsHolder.style.height = `${highest}px`;
      }

      if (this.testimonialsHandlers) {
        this.testimonialsHandlers.forEach((item) => {
          item.addEventListener("click", (e) => {
            e.preventDefault();
            const target = item.dataset.label;
            this.handleTestimonial(target);
            this.testimonialsHandlers.forEach((ele) => {
              ele.classList.remove("showing");
            });
            item.classList.add("showing");
          });
        });
      }

      // Auto-advance testimonials every 3 seconds
      this.startAutoAdvance();
    }

    handleTestimonial(target) {
      const elementTarget = this.querySelector(`[data-label-by="${target}"]`);
      this.testimonialsTexts.forEach((elem) => {
        elem.classList.remove("active");
      });
      elementTarget.classList.add("active");
      const newHeight = elementTarget.offsetHeight;
      this.textsHolder.style.height = `${newHeight}px`;

      // Update the currentIndex to the clicked testimonial
      this.currentIndex = Array.from(this.testimonialsTexts).indexOf(elementTarget);
    }

    startAutoAdvance() {
      this.interval = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.testimonialsTexts.length;
        const nextElement = this.testimonialsTexts[this.currentIndex];
        const nextLabel = nextElement.dataset.labelBy;
        this.handleTestimonial(nextLabel);

        // Update handlers to reflect the current active testimonial
        this.testimonialsHandlers.forEach((ele) => {
          ele.classList.remove("showing");
        });
        const activeHandler = this.querySelector(`[data-label="${nextLabel}"]`);
        if (activeHandler) {
          activeHandler.classList.add("showing");
        }
      }, 10000);
    }

    disconnectedCallback() {
      // Clear the interval when the element is removed from the DOM
      clearInterval(this.interval);
    }
  }

  if (typeof customElements.get("levo-logoblock") == "undefined") {
    customElements.define("levo-logoblock", LevoTestimonial);
  }
}
